<template>
  <div ref="Container">
    <el-dialog title="Đăng nhập IntrustCA" :visible.sync="isOpen" width="500px" :before-close="handleClose"
      :close-on-click-modal="false">
      <template slot="title">
        <div class="flex items-center gap-3">
          <img width="40" src="@/assets/images/logo_intrust.png" alt="IntrustCA">
          <div class="fs-20 font-bold">Đăng nhập IntrustCA</div>
        </div>
      </template>

      <div v-loading="isLoading">
        <el-form :model="form" :rules="rules" ref="loginForm" label-position="top">
          <el-form-item label="Tài khoản" prop="username">
            <el-input v-model="form.username" placeholder="Nhập tài khoản IntrustCA" clearable
              @keyup.enter.native="handleLogin">
              <i slot="prefix" class="el-input__icon el-icon-user"></i>
            </el-input>
          </el-form-item>

          <el-form-item label="Mật khẩu" prop="password">
            <el-input v-model="form.password" type="password" placeholder="Nhập mật khẩu" show-password clearable
              @keyup.enter.native="handleLogin">
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
          </el-form-item>

          <el-form-item label="Phương thức xác thực">
            <el-radio-group v-model="form.auth_method">
              <el-radio label="mobile">Xác thực ký qua App mobile</el-radio>
              <el-radio label="pin">Xác thực ký bằng PIN</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <div class="text-sm text-gray-600 mt-4">
          <p class="mb-2"><strong>Lưu ý:</strong> Vui lòng sử dụng tài khoản IntrustCA đã được cấp để đăng nhập.</p>
          <p class="mb-0">Nếu chưa có tài khoản, vui lòng liên hệ với IntrustCA để được hỗ trợ.</p>
        </div>
        <div v-if="form.auth_method == 'pin'" class="mt-2">
          <div style="font-weight:600;margin-bottom:6px;">Xác thực bằng PIN</div>
          <div style="margin-bottom:6px;">Vui lòng thực hiện các bước sau để tạo mã PIN(nếu chưa có) cho <br /> tài
            khoản
            IntrustCA:
          </div>
          <ol style="margin:0 0 6px 18px;padding:0;">
            <li>Truy cập <a href="https://rmsportal.intrustdss.vn/login" target="_blank" rel="noopener"
                style="color:#1f6feb;">https://rmsportal.intrustdss.vn</a></li>
            <li>Đăng nhập bằng tài khoản IntrustCA của bạn</li>
            <li>Vào phần <strong>Quản lý thiết bị / Tạo mã PIN</strong> và tạo mã PIN mới</li>
            <li>Quay lại HODO và đăng nhập lại bằng tài khoản IntrustCA</li>
          </ol>
          <div style="margin-top:6px;color:#666;font-size:12px;">Nếu cần hỗ trợ, liên hệ IntrustCA hoặc quản trị hệ
            thống của
            bạn.</div>
        </div>
        <div v-if="form.auth_method == 'mobile'" class="mt-2">
          <div style="font-weight:600;margin-bottom:6px;">Xác thực bằng App mobile</div>
          <div style="margin-bottom:6px;">Sau khi đăng nhập. Vui lòng mở ứng dụng <strong>IntrustCA</strong> trên điện thoại và <br /> chấp nhận
            yêu cầu
            xác thực để hoàn tất đăng nhập.</div>
          <ol style="margin:0 0 6px 18px;padding:0;">
            <li>Mở ứng dụng IntrustCA trên điện thoại của bạn.</li>
            <li>Tìm thông báo/ yêu cầu xác thực và chọn <strong>Xác nhận / Accept</strong>.</li>
            <li>Quay lại HODO và tiếp tục — đăng nhập sẽ hoàn tất sau khi bạn xác thực trên điện thoại.</li>
          </ol>
          <div style="margin-top:6px;color:#666;font-size:12px;">Nếu không nhận được yêu cầu trên điện thoại, kiểm tra
            kết nối
            mạng hoặc liên hệ <br /> bộ phận hỗ trợ IntrustCA.</div>
        </div>

        <p v-if="errorMessage" class="mt-3 text-sm text-red-600 font-light" v-html="errorMessage"></p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Hủy</el-button>
        <el-button type="primary" @click="handleLogin" :loading="isLoading">Đăng nhập</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SignatureRequest from '@/api/request/SignatureRequest'

export default {
  name: 'ModalLoginIntrustCA',
  data () {
    return {
      isOpen: false,
      isLoading: false,
      errorMessage: '',
      form: {
        username: '',
        password: '',
        auth_method: 'pin' // '' | 'mobile' | 'pin'
      },
      rules: {
        username: [{ required: true, message: 'Vui lòng nhập tài khoản', trigger: 'blur' }],
        password: [{ required: true, message: 'Vui lòng nhập mật khẩu', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleOpen () {
      this.isOpen = true
      this.resetForm()
    },
    handleClose () {
      this.isOpen = false
      this.resetForm()
    },
    resetForm () {
      if (this.$refs.loginForm) this.$refs.loginForm.resetFields()
      this.form = { username: '', password: '', auth_method: 'pin' }
      this.errorMessage = ''
      this.isLoading = false
    },
    async handleLogin () {
      try {
        const valid = await this.$refs.loginForm.validate()
        if (!valid) return

        this.isLoading = true
        this.errorMessage = ''

        const request = new SignatureRequest()
        const body = {
          username: this.form.username,
          password: this.form.password,
          is_use_pin_code: this.form.auth_method === 'pin',
          is_use_mobile_app: this.form.auth_method === 'mobile'
        }

        const response = await request.loginIntrustCA(body)
        console.log('🚀 ~ response:', response.data)

        if (response.status === 200 && response.data.success == true) {
          this.$message({ type: 'success', message: 'Đăng nhập IntrustCA thành công' })
          this.$emit('onSuccess', response.data.data.certificates || [])
          this.handleClose()
        } else {
          if (response.data.message === 'Device_id không được để trống') {
            this.$message({ type: 'warning', message: 'Vui lòng tạo mã PIN cho tài khoản IntrustCA của bạn.' })
            return
          } else {
            const message = response.data.message || 'Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin.'
            this.errorMessage = message
          }
        }
      } catch (error) {
        console.error('Login error:', error)
        const message = error.response?.data?.message || error.message || 'Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin.'
        this.errorMessage = message
        this.$message({ type: 'error', message })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
::v-deep .el-dialog__header {
  padding: 20px 20px 10px;
  border-bottom: 1px solid #f0f0f0;
}

::v-deep .el-dialog__body {
  padding: 30px 20px;
}

::v-deep .el-dialog__footer {
  padding: 10px 20px 20px;
  border-top: 1px solid #f0f0f0;
}

::v-deep .el-form-item__label {
  font-weight: 600;
  color: #333;
}

::v-deep .el-input__inner {
  height: 40px;
}

::v-deep .el-input__icon {
  line-height: 40px;
}

::v-deep .el-form-item__label {
  padding: 0;
}
</style>
